import { Component, OnInit } from '@angular/core'
import { BsModalRef } from 'ngx-bootstrap/modal'
import { ConfiguracaoIntegracaoBandeira } from '../../../shared/configuracao-integracao-bandeira'

declare const $

@Component({
    selector: 'col-configuracao-bandeira-modal-visualizacao',
    templateUrl: './configuracao-bandeira-modal-visualizacao.component.html'
})
export class ConfiguracaoBandeiraModalVisualizacaoComponent {
    configuracao: ConfiguracaoIntegracaoBandeira

    constructor(private bsModalRef: BsModalRef) {}

    fechar() {
        this.bsModalRef.hide()
    }

    selecionarTab(event: MouseEvent) {
        const $a = $(event.target)
        $a.tab('show')
    }
}



// WEBPACK FOOTER //
// ./src/app/configuracao/configuracao-integracao/configuracao-integracao-bandeira/configuracao-bandeira-modal-visualizacao/configuracao-bandeira-modal-visualizacao.component.ts